export function isDigit(str: string): boolean {
  return str === "" || /^\d*$/.test(str);
}
